import React from 'react'

export default props => (
    <ul className={`${props.classes} nav nav-tabs`}>
        {props.children}
    </ul>
)
